export default "__VITE_ASSET__DUjH81NU__"